import React from 'react';

import ContentChangeButton from '../../buttons/ContentChangeButton/ContentChangeButton';
import AdminRateCard from '../AdminRateCard/AdminRateCard';

import './AdminServiceRatesCard.css';

const AdminServiceRatesCard = ({
  service,
  onAddClickHandler,
  onEditClickHandler,
  onDeleteClickHandler,
}) => {
  return (
    <div className='services-list'>
      <div className='admin-prices-title-add-container'>
        <div className='admin-prices-category'>{service.title}</div>
        <div>
          <ContentChangeButton
            iconType='add'
            size='large'
            width='long'
            onClickHandler={() => onAddClickHandler(service)}
          >
            Add Rate
          </ContentChangeButton>
        </div>
      </div>
      <div className='admin-prices-rates-container'>
        {service.rates.map((r, i) => (
          <AdminRateCard
            key={i}
            service={service}
            rate={r}
            onEditClickHandler={onEditClickHandler}
            onDeleteClickHandler={onDeleteClickHandler}
          />
        ))}
      </div>
    </div>
  );
};

export default AdminServiceRatesCard;
